/* zsm7: shared behaviour (gallery, accordions, buy box render(), sticky bar, anchors). Guarded: runs once per page. */
(function () {
  if (window.__zsm7) return;
  window.__zsm7 = 1;
  var d = document;
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  var cfg = null, S = { qty: 1, mode: 'onetime' };

  function money(c) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function setText(sel, txt) { qa(sel).forEach(function (n) { n.textContent = txt; }); }

  function render() {
    if (!cfg) return;
    var sub = S.mode === 'subscribe' && cfg.sub != null;
    var unit = sub ? cfg.sub : cfg.once;
    var base = sub ? cfg.once : cfg.compare;
    var total = unit * S.qty;
    var ctot = base > unit ? base * S.qty : 0;
    var save = ctot > total ? ctot - total : 0;
    var modeText = sub ? cfg.labelSub : cfg.labelOnce;
    /* top price = constant unit price (per bottle); totals live in the offer cards and the sticky bar */
    var usave = base > unit ? base - unit : 0;
    setText('[data-zsm7-price]', money(unit));
    qa('[data-zsm7-each]').forEach(function (n) { n.hidden = true; });
    qa('[data-zsm7-compare]').forEach(function (n) {
      if (usave > 0) { n.textContent = money(base); n.hidden = false; } else { n.hidden = true; }
    });
    qa('[data-zsm7-save]').forEach(function (n) {
      if (usave > 0) { n.textContent = cfg.saveLabel + ' ' + money(usave); n.hidden = false; } else { n.hidden = true; }
    });
    qa('[data-offer]').forEach(function (c) {
      var k = parseInt(c.getAttribute('data-offer'), 10);
      var p = unit * k, cm = base > unit ? base * k : 0;
      var pe = q('[data-zsm7-card-price]', c), ce = q('[data-zsm7-card-compare]', c), inp = q('input[type=radio]', c);
      if (pe) pe.textContent = money(p);
      if (ce) { if (cm > p) { ce.textContent = money(cm); ce.hidden = false; } else { ce.hidden = true; } }
      c.classList.toggle('is-selected', k === S.qty);
      if (inp) inp.checked = (k === S.qty);
    });
    qa('[data-zsm7-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-zsm7-mode') === (sub ? 'subscribe' : 'onetime') ? 'true' : 'false'); });
    qa('[data-zsm7-refills]').forEach(function (n) { n.hidden = !sub; });
    qa('[data-zsm7-sub-only]').forEach(function (n) { n.hidden = !sub; });
    setText('[data-zsm7-mode-text]', modeText);
    qa('[data-zsm7-qty-input]').forEach(function (n) { n.value = S.qty; });
    qa('[data-zsm7-plan-input]').forEach(function (n) { n.value = sub ? cfg.plan : ''; n.disabled = !sub; });
    setText('[data-zsm7-sticky-price]', money(total) + ' — ' + modeText);
  }

  function setQty(k) { S.qty = k; render(); }
  function setMode(m) { S.mode = (m === 'subscribe' && cfg.sub != null) ? 'subscribe' : 'onetime'; render(); }

  function initBuy() {
    var root = q('[data-zsm7-buy]');
    var el = root && q('script[data-zsm7-cfg]', root);
    if (!el) return;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    S.mode = (cfg.sub != null && cfg.defaultMode === 'subscribe') ? 'subscribe' : 'onetime';
    window.zsm7Buy = { state: S, render: render, setQty: setQty, setMode: setMode };
    d.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name && (t.name === 'zsm7-qty' || t.name === 'zsm7-qty2')) setQty(parseInt(t.value, 10) || 1);
    });
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-zsm7-mode]');
      if (b) { setMode(b.getAttribute('data-zsm7-mode')); return; }
      var s = e.target.closest && e.target.closest('[data-zsm7-submit]');
      if (s) {
        var f = d.getElementById(root.getAttribute('data-zsm7-form'));
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      }
    });
    render();
    initSticky();
  }

  function initSticky() {
    var bar = q('[data-zsm7-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var vis = { a: false, b: false };
    function upd() { bar.hidden = !(window.scrollY > 300 && !vis.a && !vis.b); }
    var atc = q('[data-zsm7-atc]'), b2 = q('[data-zsm7-b2]');
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.target === atc) vis.a = en.isIntersecting; else vis.b = en.isIntersecting; });
      upd();
    });
    if (atc) io.observe(atc);
    if (b2) io.observe(b2);
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  function initGallery() {
    qa('[data-zsm7-gal]').forEach(function (g) {
      var tr = q('[data-track]', g), th = qa('[data-thumb]', g);
      if (!tr) return;
      function set(i) { th.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); }); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); }); });
      var raf;
      tr.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { set(Math.round(tr.scrollLeft / (tr.clientWidth || 1))); }); }, { passive: true });
      set(0);
    });
  }

  function initAcc() {
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-zsm7-acc]');
      if (!b) return;
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      var a = b.nextElementSibling;
      if (a) a.hidden = open;
    });
  }

  function initAnchors() {
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#zsm7-buy"]');
      if (!a) return;
      var t = d.getElementById('zsm7-buy');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  function init() { initBuy(); initGallery(); initAcc(); initAnchors(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { if (cfg) render(); });
})();
